import AbstractHistoryService from 'services/history/local/AbstractLocalHistoryService';

export default class DefaultLocalHistoryService extends AbstractHistoryService {
  shouldUpdateHistoryOnBoot(): boolean {
    return false;
  }

  async updateHistoryOnBoot(): Promise<void> {
    // Do nothing
  }

  shouldAlwaysSaveLocally(): boolean {
    return false;
  }
}
